import { Box, Dialog, DialogActions, DialogContent, Divider, IconButton, Typography } from "@mui/material"
import { CloseOutlined, WarningOutlined } from "@mui-symbols-material/w300"
import React, { useState } from "react"

import { Button } from "@/components/common/Button"
import type { InstructionProduct } from "@/graphql/codegen/graphql"
import { AssociatedProductsTable } from "@/screens/ManageProducts/components/Instructions/components/tables/AssociatedProductsTable"

interface RemoveProductDialogProps {
  onClose: () => void
  onSubmit: (idsToRemove: number[]) => void
  products: InstructionProduct[]
  productsFetching: boolean
}

const RemoveProductDialog: React.FC<RemoveProductDialogProps> = ({ onClose, onSubmit, products, productsFetching }) => {
  const [selectedProducts, setSelectedProducts] = useState<Record<string, boolean>>({})
  const selectedProductIds = Object.keys(selectedProducts).map(Number)
  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth='lg'>
      <IconButton aria-label='close' onClick={onClose} className='absolute right-4 top-4 text-primary'>
        <CloseOutlined />
      </IconButton>
      <Divider />
      <DialogContent classes={{ root: "p-10 flex flex-col gap-6" }}>
        <Box className='flex justify-center'>
          <WarningOutlined className='size-[48px] text-secondary-600' />
        </Box>
        <Typography color='primary' variant='h5' align='center'>
          Select Products to be removed
        </Typography>
        <Typography align='center' className='mt-6 px-3 text-base leading-[150%] tracking-[-0.85px] text-gray-700'>
          By removing your selected products from this instruction the system will automatically delete their
          association.
          <br />
          Select products and click on “Remove” if you want to proceed or “Go Back” if this action was a mistake.
        </Typography>
        <AssociatedProductsTable
          products={products}
          productsFetching={productsFetching}
          isSelectable={true}
          selected={selectedProducts}
          onProductSelection={setSelectedProducts}
        />
      </DialogContent>
      <DialogActions className='justify-between px-10 pb-10'>
        <Button appearance='outlined' onClick={onClose}>
          Go Back
        </Button>
        <Button
          disabled={!selectedProductIds?.length || productsFetching}
          onClick={() => onSubmit(selectedProductIds)}
          variant={"error"}
        >
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RemoveProductDialog
